import { Component } from 'react';

export class EnvelopeSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;
        return (
            <svg
                className={className}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M21.5999 7.80005V17.2541C21.5999 18.3352 20.7536 19.2001 19.6958 19.2001H4.30403C3.24618 19.2001 2.3999 18.3352 2.3999 17.2541V7.80005L11.709 14.1784C11.9206 14.2865 12.1321 14.2865 12.2908 14.1784L21.5999 7.80005Z"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.21324 4.80005H19.7332C20.5866 4.80005 21.3332 5.43729 21.5999 6.24832L11.9999 12.6L2.3999 6.24832C2.61324 5.43729 3.3599 4.80005 4.21324 4.80005Z"
                    />
                </g>
                <defs>
                    <clipPath id="clip0">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
}
